import Vue from "vue";
import {
  Toast
} from 'vant';
import apis from "@/config/api.config.js"
import qs from "qs";

export default {
  name: "index",
  data() {
    return {
      show: false,
      quesRes:'',

    };
  },
  methods: {
    hasSignup(){
      const that = this;
            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let post_data = {
                token: localStorage.getItem('luoohutoken'),
                activityid:that.activityid,
            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.hasSignup,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    console.log(res);
                    res = res.data;
                    if (res.code == 201) { //没有打卡
                        Toast.clear()
                        that.$router.push('/glory');
                      
                    }
                    else{//提示已经打卡
                      let toast = Toast({
                        duration: 2000, // 持续展示 toast
                        forbidClick: true,
                        message: res.msg,
                        onClose:function(){
                          that.$router.replace('/');
                        },
                    });
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });  
    },
  },

  created() {
    console.log('created');
    console.log(this.$route.params);
    const that = this;
    that.quesRes = that.$route.params.status;
    that.activityid = that.$route.params.activityid;

  },

};